import React, { useContext, useEffect, useState } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { Input } from "../../Input";
import { copy } from "../../../services/Functions";
import { ContainerFreteEspecial } from "./styles";
import { FreteEspecial as FreteEspecialType } from "../../../types/FreteEspecial";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { cepMask, currencyMask } from "../../../services/Masks";
import { validateCep } from "../../../services/MasksValidations";
import { unmaskToNumbers } from "../../../services/Unmasks";
import PopoverInfo from "../../PopoverInfo/PopoverInfo";
import Swal from "sweetalert2";

interface FreteEspecialProps {
  index: number;
  onExclusaoFreteEspecial: (newLenght) => void;
  configIn: "empresa" | "configuracoes";
}

const FreteEspecial: React.FC<FreteEspecialProps> = ({
  onExclusaoFreteEspecial,
  index,
  configIn,
}) => {
  const { fretes_especiais, setFretes_especiais, configuracoes } =
    useContext(ConfiguracoesContext);

  const [descricaoDuplicada, setDescricaoDuplicada] = useState(false);

  function handleInputChange(newValue: string, name?: string): void {
    let newFretesEspeciais = [...fretes_especiais];
    newFretesEspeciais[indexFrete][name!] = newValue;
    setFretes_especiais(newFretesEspeciais);
  }
  
  function handleDescricaoBlur(): void {
    const nome = fretes_especiais[indexFrete].descricao;
    if (isNomeDuplicado(nome)) {
      setDescricaoDuplicada(true);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Esta descrição está duplicada, por favor, insira outra descrição.",
      });
      return;
    }
    setDescricaoDuplicada(false);
  }

  
  function isNomeDuplicado(nome: string): boolean {
    return fretes_especiais.some((frete, idx) => 
      idx !== indexFrete && frete.descricao.trim().toLowerCase() === nome.trim().toLowerCase()
    );
  }
  

  const { theme } = useTheme();

  const [indexFrete, setIndexFrete] = useState<number>(index);

  useEffect(() => {
    if (index === -1) {
      const newFretesEspeciais: FreteEspecialType[] = [...fretes_especiais];
      newFretesEspeciais.push({
        descricao: "",
        cep_inicio: "",
        cep_fim: "",
        prazo: "",
        valor: "",
        valor_minimo: "0",
        peso_minimo: "",
        peso_maximo: "",
        ativo: true,
      });
      setFretes_especiais(newFretesEspeciais);
      setIndexFrete(newFretesEspeciais.length - 1);
    }
  }, [index]);

  return (
    <>
      <ContainerFreteEspecial configIn={configIn} theme={theme}>
        {fretes_especiais.length > 0 && fretes_especiais[indexFrete] && (
          <div className="containerFreteEspecial">
            {configIn === "empresa" && (
              <Titulo
                titulo="Entrega Especial"
                subtitulo={"Configure os dados da sua entrega especial"}
                flexDirection="column-reverse"
              />
            )}
            <Input
              type={""}
              maxLength={70}
              showMaxLength={false}
              value={fretes_especiais[indexFrete].descricao}
              placeholder={"Nome da entrega Especial"}
              onChange={handleInputChange}
              onBlur={handleDescricaoBlur}
              label="Descrição"
              alignLabel="left"
              required={configuracoes.frete.freteEspecialAtivo}
              ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
              name="descricao"
            />
            <div className="gridInput gridInputTres">
              <Input
                type={""}
                value={fretes_especiais[indexFrete].cep_inicio.toString()}
                placeholder={"00000-000"}
                onChange={handleInputChange}
                label="CEP Início"
                alignLabel="left"
                mask={{
                  mask: cepMask,
                  maskValidation: validateCep,
                  unmask: unmaskToNumbers,
                }}
                required={configuracoes.frete.freteEspecialAtivo}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                name="cep_inicio"
                disabled={descricaoDuplicada}
              ></Input>
              <Input
                type={""}
                value={fretes_especiais[indexFrete].cep_fim.toString()}
                placeholder={"99999-999"}
                mask={{
                  mask: cepMask,
                  maskValidation: validateCep,
                  unmask: unmaskToNumbers,
                }}
                onChange={handleInputChange}
                label="CEP Fim"
                alignLabel="left"
                required={configuracoes.frete.freteEspecialAtivo}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                name="cep_fim"
                disabled={descricaoDuplicada}
              ></Input>
              <Input
                type={"number"}
                value={
                  Number.parseInt(fretes_especiais[indexFrete].prazo) > 0
                    ? fretes_especiais[indexFrete].prazo.toString()
                    : ""
                }
                placeholder={"2 dias"}
                max={999}
                onChange={handleInputChange}
                label="Prazo de Entrega"
                alignLabel="left"
                required={configuracoes.frete.freteEspecialAtivo}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                name="prazo"
                disabled={descricaoDuplicada}
              ></Input>
            </div>
            <div className="gridInput">
              <Input
                type={""}
                mask={{
                  mask: currencyMask,
                  unmask: unmaskToNumbers,
                }}
                value={
                  Number.parseFloat(fretes_especiais[indexFrete].valor) >= 0
                    ? fretes_especiais[indexFrete].valor.toString()
                    : ""
                }
                placeholder={"R$ 0,00"}
                name="valor"
                onChange={handleInputChange}
                label="Valor"
                required={false}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                alignLabel="left"
                disabled={descricaoDuplicada}
              ></Input>
              <Input
                type={"text"}
                mask={{
                  mask: currencyMask,
                  unmask: unmaskToNumbers,
                }}
                value={
                  Number.parseFloat(fretes_especiais[indexFrete].valor_minimo) > 0
                    ? fretes_especiais[indexFrete].valor_minimo.toString()
                    : "0"
                }
                placeholder={"R$ 0,00"}
                name="valor_minimo"
                onChange={handleInputChange}
                label="Valor mínimo da sacola"
                labelIcon={
                  <PopoverInfo
                    mensagem="Valor mínimo da compra para liberar esta entrega especial."
                    width="18"
                    style={{ alignSelf: "center" }}
                  />
                }
                required={false}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                alignLabel="left"
                disabled={descricaoDuplicada}
              ></Input>
            </div>
            <div className="gridInput">
              <Input
                type={"number"}
                value={
                  fretes_especiais[indexFrete].peso_minimo || "0"
                }
                placeholder={"0"}
                min={0}
                max={9999999}
                name="peso_minimo"
                required={configuracoes.frete.freteEspecialAtivo}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                onChange={handleInputChange}
                label="Peso mínimo (g)"
                alignLabel="left"
                disabled={descricaoDuplicada}
              ></Input>
              <Input
                type={"number"}
                value={
                  Number.parseFloat(fretes_especiais[indexFrete].peso_maximo) >
                  0
                    ? fretes_especiais[indexFrete].peso_maximo.toString()
                    : ""
                }
                placeholder={"1000"}
                max={9999999}
                required={configuracoes.frete.freteEspecialAtivo}
                ignoreValidations={!configuracoes.frete.freteEspecialAtivo}
                name="peso_maximo"
                onChange={handleInputChange}
                label="Peso máximo (g)"
                alignLabel="left"
                disabled={descricaoDuplicada}
              ></Input>
            </div>
            {/* ajustar depois para inativar, não excluir 
            <div className="exclusao fonteTexto">
              <span
                onClick={() => {
                  let newFretes_especiais = [...fretes_especiais];
                  newFretes_especiais.splice(indexFrete, 1);
                  setFretes_especiais(newFretes_especiais);
                  onExclusaoFreteEspecial(newFretes_especiais.length);
                }}
              >
                Excluir{" "}
                {fretes_especiais[indexFrete].descricao
                  ? fretes_especiais[indexFrete].descricao
                  : "regra de entrega especial"}
              </span>
            </div> */}
          </div>
        )}
      </ContainerFreteEspecial>
    </>
  );
};
export default FreteEspecial;
